/**
 * Bank profile hooks (P251/P252) -- read + update the deployment's bank
 * identity (name + logo + accent) that brands generated outputs.
 */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";

import { api } from "shared/api/client";
import type { BankProfile, BankProfilePatch } from "shared/api/types";

const KEY = ["admin-bank-profile"] as const;

export function useBankProfile(): UseQueryResult<BankProfile> {
  return useQuery<BankProfile>({
    queryKey: KEY,
    queryFn: () => api.get<BankProfile>("/v1/admin/bank-profile"),
  });
}

export function usePatchBankProfile(): UseMutationResult<
  BankProfile,
  Error,
  BankProfilePatch
> {
  const qc = useQueryClient();
  return useMutation<BankProfile, Error, BankProfilePatch>({
    mutationFn: (body) => api.patch<BankProfile>("/v1/admin/bank-profile", body),
    onSuccess: (data) => {
      qc.setQueryData(KEY, data);
    },
  });
}
